import { createAsyncThunk } from '@reduxjs/toolkit';
import eventAnalyticsApi from '@infrastructure/event-analytics';
import { getErrorPayload } from '@application/helpers/api-helper';
export const getEventAnalytics = createAsyncThunk('eventDashboard/getEventAnalytics', async (id, { rejectWithValue }) => {
    try {
        const response = await eventAnalyticsApi.getEventAnalytics(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventResponsesAnalytics = createAsyncThunk('eventDashboard/getEventResponsesAnalytics', async (id, { rejectWithValue }) => {
    try {
        const response = await eventAnalyticsApi.getEventResponsesAnalytics(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
